class TipsStorage {
    #getKey(pageName) {
        return `tips:shown:${pageName}`;
    }

    isPageShown(pageName) {
        const key = this.#getKey(pageName);
        return sessionStorage.getItem(key) === "true";
    }

    markAsShown(pageName) {
        const key = this.#getKey(pageName);
        sessionStorage.setItem(key, "true");
    }
}

export const tipsStorage = new TipsStorage();
